import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteInventoryBoxQr } from "./deleteInventoryBoxQr.request";

const useDeleteInventoryBoxQr = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestDeleteInventoryBoxQr,
    onError: toastServerError,
    ...options
  });
};

export default useDeleteInventoryBoxQr;
